<template>
  <v-row class="mb-n3">
    <v-col cols="12" lg="3">
      <v-text-field
        :label="
          fromPage == 'customer'
            ? 'ค้นหาจากชื่อ / รหัสลูกค้า'
            : 'ค้นหารหัสสัญญา / รหัสลูกค้า'
        "
        v-model="searchName"
        dense
        outlined
      ></v-text-field>
    </v-col>
    <v-col
      v-if="this.isfromNew == !true"
      cols="12"
      :lg="fromPage == 'customer' ? 2 : 3"
    >
      <v-select
        label="กลุ่มโรงพยาบาล"
        :items="GroupHops"
        v-model="searchGroupHops"
        dense
        outlined
      ></v-select>
    </v-col>
    <v-col
      v-if="this.isfromNew == true && this.fromPage != 'confirm_customer'"
      class="mt-1"
      cols="12"
      lg="3"
    >
      <date-picker
        placeholder="วันที่ติดต่อ"
        v-model="searchDate"
        :format="momentFormat"
        dense
        outlined
      ></date-picker>
    </v-col>
    <v-col
      v-if="this.isfromNew == true && this.fromPage == 'confirm_customer'"
      class="mt-1"
      cols="12"
      lg="3"
    >
      <date-picker
        placeholder="เลือกช่วงวันที่"
        :format="momentFormat"
        v-model="search_range_dates"
        range
      ></date-picker>
    </v-col>
    <v-col v-else cols="12" lg="2">
      <v-select
        v-if="fromPage == 'customer'"
        label="สถานะ"
        v-model="searchStatus"
        :items="TypeStatus"
        dense
        outlined
      ></v-select>
      <v-select
        v-else-if="fromPage == 'contract'"
        label="ประเภท"
        v-model="searchStatus"
        :items="contract_category"
        dense
        outlined
      ></v-select>
      <v-select
        v-else-if="fromPage == 'ex_contract'"
        label="ประเภท"
        v-model="searchStatus"
        :items="contract_category"
        dense
        outlined
      ></v-select>
    </v-col>
    <v-col v-if="fromPage == 'customer'" cols="12" lg="2" class="mr-n10">
      <v-checkbox
        label="มียอดค้างชำระ"
        v-model="IsDebt"
        class="mt-3"
      ></v-checkbox>
    </v-col>
    <v-col cols="12" lg="1" class="mr-5">
      <v-btn color="default" elevation="1" class="pa-5" @click="Search">
        <v-icon left>mdi-magnify</v-icon>ค้นหา
      </v-btn>
    </v-col>
    <v-col cols="12" lg="1">
      <v-btn color="default" class="pa-5" elevation="1" @click="Clear">
        <v-icon left>mdi-close</v-icon>ล้าง
      </v-btn>
    </v-col>
  </v-row>
</template>
<script>
import moment from "moment";
export default {
  name: "filterCustomer",
  props: {
    isfromNew: Boolean,
    fromPage: String,
  },
  data() {
    return {
      search_range_dates: "",
      searchDate: "",
      searchStatus: "",
      searchGroupHops: "",
      searchName: "",
      IsDebt: false,
      TypeStatus: [
        "รอเสนอราคา",
        "รอวางบิล",
        "รอการชำระเงิน",
        "รอทำสัญญา",
        "ดำเนินการ",
        "หมดสัญญา",
        "ยกเลิก",
      ],
      contract_category: ["รายปี", "รายเดือน", "คิดตามกิโลกรัม"],
      GroupHops: ["รพ.ใหญ่", "รพ.เล็ก"],
      momentFormat: {
        // Date to String
        stringify: (date) => {
          return date
            ? moment(date)
                .add(543, "year")
                .locale("th")
                .format("LL")
            : "";
        },
        // String to Date
        parse: (value) => {
          return value ? moment(value, "LL").toDate() : null;
        },
      },
    };
  },
  created() {},
  methods: {
    Search() {
      if (this.fromPage == "customer") {
        let data = {
          D: this.searchDate
            ? moment(this.searchDate).format("YYYY-MM-DD")
            : this.searchDate,
          S: this.searchStatus ? this.searchStatus : "%",
          G: this.searchGroupHops,
          N: this.searchName,
          F: this.isfromNew,
          P: this.IsDebt,
        };
        console.log(data);
        this.$token_api
          .post("/search-filter-customer", data)
          .then((res) => {
            this.$emit("returnDessert", res.data.data);
          })
          .catch((err) => {
            console.log(err);
          });
      } else if (this.fromPage == "qr_customer") {
        let data = {
          D: this.searchDate
            ? moment(this.searchDate).format("YYYY-MM-DD")
            : this.searchDate,
          S: this.searchStatus ? this.searchStatus : "%",
          G: this.searchGroupHops,
          N: this.searchName,
          F: this.isfromNew,
          P: this.IsDebt,
        };
        console.log(data);
        this.$token_api
          .post("/search-filter-qr-customer", data)
          .then((res) => {
            this.$emit("returnDessert", res.data.data);
          })
          .catch((err) => {
            console.log(err);
          });
      } else if (this.fromPage == "contract") {
        let data = {
          D: this.searchDate
            ? moment(this.searchDate).format("YYYY-MM-DD")
            : this.searchDate,
          S: this.searchStatus,
          G: this.searchGroupHops,
          N: this.searchName,
          F: this.isfromNew,
        };
        this.$token_api
          .post("/get-all-contract", data)
          .then((res) => {
            this.$emit("returnContract", res.data.data);
          })
          .catch((err) => {
            console.log(err);
          });
      } else if (this.fromPage == "ex_contract") {
        let data = {
          D: this.searchDate
            ? moment(this.searchDate).format("YYYY-MM-DD")
            : this.searchDate,
          S: this.searchStatus,
          G: this.searchGroupHops,
          N: this.searchName,
          F: this.isfromNew,
        };
        this.$token_api
          .post("/list-expire-contract", data)
          .then((res) => {
            this.$emit("returnExContract", res.data.data);
          })
          .catch((err) => {
            console.log(err);
          });
      } else if (this.fromPage == "confirm_customer") {
        let s_d1 = "";
        let s_d2 = "";
        if (this.search_range_dates) {
          s_d1 = this.search_range_dates
            ? moment(this.search_range_dates[0]).format("YYYY-MM-DD 00:00:00")
            : this.search_range_dates;

          s_d2 = this.search_range_dates
            ? moment(this.search_range_dates[1]).format("YYYY-MM-DD 23:59:59")
            : this.search_range_dates;
        }
        let data = {
          D: this.searchDate
            ? moment(this.searchDate).format("YYYY-MM-DD")
            : this.searchDate,
          G: this.searchGroupHops,
          N: this.searchName,
          F: this.isfromNew,
          s_d1: s_d1,
          s_d2: s_d2,
        }; 
        this.$token_api
          .post("/search-filter-confirmcustomer", data)
          .then((res) => {
            // console.log(res.data.data);
            this.$emit("returnDessert", res.data.data);
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    Clear() {
      this.search_range_dates = "";
      this.searchDate = "";
      this.searchStatus = "";
      this.searchGroupHops = "";
      this.searchName = "";
      this.IsDebt = false;
    },
  },
};
</script>
